import { Theme, makeStyles, createStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing(2),
      display: "flex",
      flexDirection: "column",
    },
    title: {
      color: theme.palette.common.black,
      fontWeight: "bold",
      fontSize: "18px",
    },
    subtitle: {
      color: theme.palette.common.black,
      opacity: 0.5,
      marginTop: "3px",
      fontSize: "14px",
      fontWeight: "bold",
      lineHeight: "17px",
    },
  })
);
